<template>
    <div class="schedule">
        <img class="title" src="../../assets/images/schedule.png" alt="" />
        <div class="swiper-wrap">
            <div class="time">
                <p>2021-01</p>
                <ul>
                    <li
                        :class="{ active: activeIndexVal == 0 }"
                        @click="swiperHandle(0)"
                    >
                        27
                    </li>
                    <li
                        :class="{ active: activeIndexVal == 1 }"
                        @click="swiperHandle(1)"
                    >
                        28
                    </li>
                    <li
                        :class="{ active: activeIndexVal == 2 }"
                        @click="swiperHandle(2)"
                    >
                        29
                    </li>
                    <li
                        :class="{ active: activeIndexVal == 3 }"
                        @click="swiperHandle(3)"
                    >
                        30
                    </li>
                </ul>
            </div>
            <swiper
                class="swiper"
                :class="{ 'swiper-whole': isSpecial }"
                :options="swiperOption"
                v-if="swiperArr"
                ref="mySwiper"
            >
                <swiper-slide>
                    <div class="item">
                        <div class="left-info">
                            <span>1月</span>
                            <p>27日</p>
                        </div>
                        <div class="right-info">
                            <p>省政协十二届四次会议开幕会</p>
                            <p>联组会议</p>
                            <p>分组会议</p>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="item">
                        <div class="left-info">
                            <span>1月</span>
                            <p>28日</p>
                        </div>
                        <div class="right-info">
                            <p>列席省十三届人大四次会议开幕式</p>
                            <p>听取省政府工作报告</p>
                            <p>联组会议、分组会议</p>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="item">
                        <div class="left-info">
                            <span>1月</span>
                            <p>29日</p>
                        </div>
                        <div class="right-info">
                            <p>省政协十二届四次会议第二次全体会议</p>
                            <p>提案委员会全体会议</p>
                            <p>分组会议、主席会议、常委会会议</p>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="item">
                        <div class="left-info">
                            <span>1月</span>
                            <p>30日</p>
                        </div>
                        <div class="right-info">
                            <p>分组会议</p>
                            <p>省政协十二届四次会议闭幕会</p>
                            <p>省政协主席张昌尔讲话</p>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';
export default {
    name: 'Schedule',
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        swiperArr: {
            type: Array,
            default: () => [],
        },
        isSpecial: {
            type: Boolean,
            default: false,
        },
    },
    computed: {},
    data() {
        let self = this;
        return {
            activeIndexVal: 0,
            swiperOption: {
                initialSlide: 0,
                // autoplay: {
                //   delay: 2500,
                //   disableOnInteraction: false
                // },
                on: {
                    slideChange() {
                        self.activeIndexVal = this.activeIndex;
                    },
                },
            },
        };
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        // 跳转详情
        detailHandle(strId) {
            let routeData = this.$router.resolve({
                path: '/detail',
                query: {
                    strWebSiteId: this.$route.query.strWebSiteId,
                    strId: strId,
                },
            });
            window.open(routeData.href, '_blank');
        },
        swiperHandle(val) {
            this.$nextTick(function() {
                this.$refs.mySwiper.$swiper.slideTo(val, 500, true);
            });
        },
    },
};
</script>

<style scoped lang="scss">
.schedule {
    width: 660px;
    margin-top: -13px;
    .title {
        display: block;
        width: 100%;
        height: auto;
        margin: 0 auto;
    }
    .swiper-wrap {
        background: #fffbef;
        box-sizing: border-box;
        padding: 10px 15px 15px;
        .time {
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
                display: inline-block;
                color: #e2201c;
                text-shadow: 0 0 #e2201c;
                border-radius: 8px;
                background-color: #f7d02b;
                box-sizing: border-box;
                padding: 0 10px;
                line-height: 30px;
                font-size: 17px;
                margin: 0;
            }
            ul {
                flex: 1;
                overflow: hidden;
                margin: 0 0 0 20px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                background: url('../../assets/images/line.jpg') repeat-x center
                    center;
                li {
                    height: 48px;
                    width: 48px;
                    border-radius: 4px;
                    line-height: 48px;
                    border: 1px solid #e2201c;
                    color: #e2201c;
                    font-size: 26px;
                    text-align: center;
                    cursor: pointer;
                    background: #fff;
                    display: inline-block;
                }
                .active {
                    background: #e2201c;
                    color: #fff;
                }
            }
        }
    }
    .swiper {
        width: 100%;
        height: 130px;
        margin-top: 15px;
        .swiper-slide {
            display: flex;
            justify-content: center;
            align-items: center;
            background-size: cover;
            overflow: hidden;
            .item {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                padding: 20px;
                .left-info {
                    width: 110px;
                    height: 103px;
                    background: url('../../assets/images/schedule1.png')
                        no-repeat center center;
                    text-align: center;
                    margin-right: 50px;
                    span {
                        display: block;
                        font-weight: bold;
                        font-size: 16px;
                        color: white;
                        line-height: 52px;
                    }
                    p {
                        font-size: 30px;
                        color: #000;
                        display: block;
                        font-weight: bold;
                    }
                }
                .right-info {
                    p {
                        font-size: 18px;
                        line-height: 36px;
                        color: #333;
                        margin: 0;
                    }
                }
            }
            img {
                display: block;
                width: 100%;
                height: auto;
                margin: 0 auto;
            }
        }
        .swiper-pagination {
            bottom: 3px;
            box-sizing: border-box;
            padding: 0 5px;
            text-align: center;
            z-index: 1;
            right: 0;
            left: 0;
            width: auto;
            /deep/ .swiper-pagination-bullet {
                width: 12px;
                height: 12px;
                background: #fff;
                display: inline-block;
                border-radius: 100%;
                position: relative;
                margin: 0 3px;
                opacity: 1;
                cursor: pointer;
                &:hover {
                    opacity: 1;
                }
                &.swiper-pagination-bullet-active {
                    background-image: linear-gradient(
                        to right,
                        #f71d1d,
                        #fba548
                    );
                    opacity: 1;
                }
            }
        }
    }
    .swiper-whole {
        width: 100%;
        height: 750px;
        .swiper-slide {
            display: block;
            p {
                font-size: 24px;
                height: 60px;
                line-height: 60px;
                padding: 0 20px;
            }
        }
        .swiper-pagination {
            bottom: 20px;
        }
    }
}
</style>
